import { render, staticRenderFns } from "./ShiftDetail.vue?vue&type=template&id=4c085324&"
import script from "./ShiftDetail.vue?vue&type=script&lang=js&"
export * from "./ShiftDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports